import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpServiceService } from './base-http-service.service';
import { TranslateService } from '@ngx-translate/core';
import { CurrentUserService } from './current-user.service';

/**
 * Interface for active session data
 */
export interface ActiveSession {
  id: string;
  deviceFingerprint: string;
  ipAddress: string;
  userAgent: string;
  deviceName: string;
  location?: string;
  createdAt: Date;
  lastActivityAt: Date;
  expiresAt: Date;
  isCurrent: boolean;
}

/**
 * Interface for authentication event
 */
export interface AuthenticationEvent {
  id: number;
  userId?: number;
  eventType: string;
  success: boolean;
  ipAddress?: string;
  userAgent?: string;
  deviceFingerprint?: string;
  location?: string;
  timestamp: Date;
  errorMessage?: string;
  additionalData?: string;
}

/**
 * Service for managing user sessions
 * SECURITY FIX: VAPT Issue #3 - Iteration 2
 */
@Injectable({
  providedIn: 'root',
})
export class SessionService extends BaseHttpServiceService {
  constructor(
    http: HttpClient,
    translateService: TranslateService,
    currentUserService: CurrentUserService
  ) {
    super(http, translateService, currentUserService);
  }

  /**
   * Get all active sessions for the current user
   */
  getActiveSessions(): Observable<ActiveSession[]> {
    const url = `${this.mysteryShopperUrl}/Session/active`;
    return this.getData<ActiveSession[]>(url);
  }

  /**
   * Revoke a specific session
   * @param sessionId The ID of the session to revoke
   */
  revokeSession(sessionId: string): Observable<{ message: string }> {
    const url = `${this.mysteryShopperUrl}/Session/${sessionId}/revoke`;
    return this.postData<{ message: string }>(url, {});
  }

  /**
   * Get authentication history for the current user
   * @param days Number of days of history to retrieve (default: 30)
   */
  getAuthHistory(days: number = 30): Observable<AuthenticationEvent[]> {
    const url = `${this.mysteryShopperUrl}/Session/history?days=${days}`;
    return this.getData<AuthenticationEvent[]>(url);
  }
}
